import React from 'react';
import {StyledGrid} from "./UsersGrid.styles";

export const UsersGrid: React.FC = (props) => {
    return <StyledGrid {...props}/>
};
